var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccessibility(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 34,
    height: 34,
    rx: 17,
    stroke: "#828282",
    strokeWidth: 2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2111_1703)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.9336 24.4805C27.7151 23.8262 27.0145 23.4711 26.3527 23.6906L25.5957 23.9421L23.9668 20.037C23.7773 19.5273 23.3203 19.25 22.8086 19.25H18.9891L18.5828 17.375H21.1262C21.8172 17.375 22.3762 16.816 22.3762 16.125C22.3762 15.434 21.8172 14.875 21.1262 14.875H18.041L17.9844 14.6094C17.8359 13.5508 16.875 12.875 15.8594 13.0195C14.8008 13.1641 14.1211 14.1133 14.2695 15.1406L15.1945 20.625C15.2578 21.2656 15.7969 21.75 16.4375 21.75H21.9609L23.7133 25.9648C23.9102 26.4492 24.3789 26.75 24.875 26.75C25.0056 26.75 25.1399 26.7292 25.2703 26.6853L27.1453 26.0603C27.8008 25.8438 28.1523 25.1367 27.9336 24.4805ZM14.25 26.125C11.8375 26.125 9.875 24.1625 9.875 21.75C9.875 19.6309 11.3898 17.8613 13.393 17.4609L13.082 15.6172C10.1898 16.1641 8 18.6992 8 21.75C8 25.202 10.798 28 14.25 28C17.2734 28 19.793 25.8527 20.375 23H18.457C17.8789 24.8008 16.2266 26.125 14.25 26.125ZM15.5 11.75C16.5355 11.75 17.375 10.9105 17.375 9.875C17.375 8.83945 16.5352 8 15.5 8C14.4648 8 13.625 8.83945 13.625 9.875C13.625 10.9105 14.4648 11.75 15.5 11.75Z",
    fill: "#828282"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2111_1703"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(8 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccessibility);
export default __webpack_public_path__ + "static/media/accessibility.1ef0a33edf145becfee177514aca5a6a.svg";
export { ForwardRef as ReactComponent };